<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="float-start">
        <h6>Service table</h6>
      </div>
      <div class="float-end">
        <div class="row">
          <div class="col-4">
            <select name="pagesx" id="pagesx" v-model="pages" @change="changepages" class="form-select form-select-sm">
              <option value="advisory">Advisory</option>
              <option value="bom">BOM</option>
              <!-- <option value="advisory_main">Advisory Main</option> -->
              <!-- <option value="bom_main">BOM Main</option> -->
            </select>
          </div>

          <div class="col-4">
            <div class="input-group mb-3">
              <input type="search" class="form-control form-control-sm" placeholder="Cari title disini..." id="cari"
                name="cari" v-model="searchQuery" aria-label="Recipient's username" aria-describedby="cari">
              <button class="btn btn-outline-secondary btn-sm" style="margin-bottom: 0%;" type="button" id="cari"
                @click="cari"><i class="fas fa-search"></i></button>
            </div>
          </div>
          <div class="col-4">
            <!-- Button to open the modal -->
            <button class="btn btn-sm btn-dark me-2" @click="showModal = true">
              <i class="fa fa-plus"></i> Add Service
            </button>
          </div>

        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert v-if="alertstatus != null" :color="alertstatus">
        <strong>{{ alertstatus }}</strong> {{ alerttext }}
      </argon-alert>
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Cover
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Title
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Detail
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Action
              </th>

            </tr>
          </thead>
          <tbody>
            <!-- Loop through banner_list and populate rows -->
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td>
                <div class="btn-group me-4">
                  <button @click="moveUp(index, item.id)" :disabled="index === 0" class="btn btn-outline-primary btn-sm">
                    <i class="fas fa-arrow-up"></i> Move Up
                  </button>
                  <button @click="moveDown(index,  item.id)" :disabled="index === paginatedData.length - 1"
                    class="btn btn-outline-danger btn-sm">
                    <i class="fas fa-arrow-down"></i> Move Down
                  </button>
                </div>

                <img :src="item.cover" alt="cover" style="width: 100px; height: auto" />
              </td>
              <td><img :src="item.cover" alt="cover" style="width: 100px; height: auto;"></td>
              <td>{{ item.title }}</td>
              <td>
                <div class="row align-items-center text-center">
                  <div class="col-sm" v-for="(detail, idx) in item.service_detail_data" :key="idx">
                    <div class="card">
                      <div class="card-body">
                        <img :src="detail.file" alt="cover" class="img-fluid" style="width: 100px; height: auto;">
                        <div v-html="truncateHTML(detail?.description, 50)"></div>
                      </div>
                      <div class="card-footer" style="padding: 0%;">
                        <button type="button" class="btn btn-sm btn-primary" @click="editdetail(detail)"><i
                            class="fa fa-edit"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <!-- Action buttons (like edit/delete) can go here -->
                <button type="button" class="btn btn-sm btn-primary me-2" @click="edit(item)"><i
                    class="fa fa-edit"></i></button>
                <button type="button" class="btn btn-sm btn-danger" @click="hapus(item?.id)"><i
                    class="fa fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <argon-pagination>
          <!-- Previous Page Button -->
          <argon-pagination-item prev :disabled="currentPage === 1" @click="prevPage" />

          <!-- Page Numbers -->
          <argon-pagination-item v-for="page in totalPages" :key="page" :label="String(page)"
            :active="currentPage === page" @click="setPage(page)" />

          <!-- Next Page Button -->
          <argon-pagination-item next :disabled="currentPage === totalPages" @click="nextPage" />
        </argon-pagination>
      </div>

      <div :class="showModal == true ? 'modal-backdrop' : ''"></div>
      <div class="modal fade" :class="showModal == true ? 'show' : ''" tabindex="-1" aria-labelledby="modalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered custom-width-modal">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalLabel" v-if="method == 'add'">Add New Service</h5>
              <h5 class="modal-title" id="modalLabel" v-else>Edit Service</h5>
              <button type="button" class="btn btn-secondary btn-sm" @click="closeModal">X</button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitForm">
                <div class="mb-3" v-if="method != 'editdetail'">
                  <label for="title" class="form-label">Title</label>
                  <input type="text" class="form-control" v-model="formData.title" id="title" required>
                </div>
                <div class="mb-3" v-if="method != 'editdetail'">
                  <label for="cover" class="form-label">Cover</label>
                  <input type="file" ref="coverRef" class="form-control" @change="handleFileUploadCover" :required="method === 'add'"
                    accept="image/*">
                  <div v-if="imgreview" class="m-4">
                    <img :src="imgreview" alt="" srcset="" style="max-height: 100px;">
                  </div>
                </div>
                <div class="mb-3" v-if="method === 'add'">
                  <label for="pages" class="form-label">Pages</label>
                  <select name="pages" id="pages" v-model="formData.pages" class="form-select">
                    <option value="advisory">Advisory</option>
                    <option value="bom">BOM</option>
                    <!-- <option value="advisory_main">Advisory Main</option> -->
                    <!-- <option value="bom_main">BOM Main</option> -->
                  </select>
                </div>
                <div class="mb-3" v-if="method != 'editdetail'">
                  <label for="category_id" class="form-label">Category</label>
                  <select name="category_id" id="category_id" class="form-select" v-model="selectCategory">
                    <option v-for="(item, index) in dataCategory" :key="index" :value="item.id">{{ item.category_name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3" v-if="method != 'editdetail'">
                  <label for="option_content" class="form-label">Pilih Icon</label>
                  <div class="icon-radio-group">
                    <label v-for="(icon, idx) in iconList" :key="idx" class="icon-radio">
                      <input type="radio" :value="icon.icon" v-model="formData.icon" />
                      <img :src="icon.icon" :alt="icon.name" class="icon-image" />
                      <span>{{ icon.name }}</span>
                    </label>
                  </div>

                  <!-- Pratinjau Ikon yang Dipilih -->
                  <div class="mt-2">
                    <p>Ikon Terpilih:</p>
                    <img :src="formData.icon" alt="Selected Icon" v-if="formData.icon"
                      style="width: 40px; height: 40px;" />
                  </div>
                </div>


                <div class="mb-3" v-if="method == 'add'">
                  <label for="is_active" class="form-label">Status</label>
                  <select name="is_active" id="is_active" class="form-select" v-model="formData.is_active">
                    <option :value="true">Active
                    </option>
                    <option :value="false">Inactive
                    </option>
                  </select>
                </div>



                <div v-if="formData.pages == 'bom' || formData.pages == 'advisory'">
                  <div v-if="method == 'add'">
                    <div v-for="(item, index) in jmldetail" :key="index">
                      <div class="mb-3" v-if="method == 'add'">
                        <label for="deskripsi" class="form-label">Deskripsi {{ index + 1 }}</label>
                        <QuillEditor ref="descriptionRef" theme="snow" v-model:content="formData.desciption[index]" contentType="html"
                          :modules="modules" toolbar="full" class="large-editor" />
                        <small class="text-danger">*Tambahkan https:// jika itu link</small>
                      </div>
                      <div class="mb-3" v-if="method == 'add' || method == 'editdetail'">
                        <label for="file" class="form-label">File {{ index + 1 }}</label>
                        <input type="file" ref="fileRef" class="form-control" @change="handleFileUpload($event, index)"
                          :required="method === 'add'" accept="image/*" v-if="method == 'add'">
                        <input type="file" class="form-control" @change="handleFileUploaddetail"
                          :required="method === 'add'" accept="image/*" v-if="method == 'editdetail'">
                        <small class="text-danger">*Max resolusi 1080x607 (Rekomendasi)</small>
                      </div>
                      <div class="mb-3" v-if="method == 'editdetail'">
                        <label for="deskripsi" class="form-label">Deskripsi</label>
                        <QuillEditor theme="snow" v-model:content="formData.desciption" contentType="html"
                          :modules="modules" class="large-editor" toolbar="full" />
                        <small class="text-danger">*Tambahkan https:// jika itu link</small>
                      </div>
                      <!-- Remove Button -->
                      <div class="text-end" v-if="index >= 1">
                        <button type="button" class="btn btn-sm btn-danger" @click="removeDetail(index)">
                          <i class="fas fa-minus"></i> Remove
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Add Button -->
                  <div v-if="method == 'add'">
                    <button type="button" class="btn btn-sm btn-success" @click="addDetail">
                      <i class="fas fa-plus"></i> Add
                    </button>
                  </div>

                  <div v-else>
                    <div class="mb-3" v-if="method == 'editdetail'">
                      <label for="deskripsi" class="form-label">Deskripsi</label>
                      <QuillEditor theme="snow" v-model:content="formData.desciption" contentType="html"
                        :modules="modules" class="large-editor" toolbar="full" />
                      <small class="text-danger">*Tambahkan https:// jika itu link</small>
                    </div>
                    <div class="mb-3" v-if="method == 'add' || method == 'editdetail'">
                      <label for="file" class="form-label">File</label>
                      <input type="file" class="form-control" @change="handleFileUpload($event, index)"
                        :required="method === 'add'" accept="image/*" v-if="method == 'add'">
                      <input type="file" class="form-control" @change="handleFileUploaddetail"
                        :required="method === 'add'" accept="image/*" v-if="method == 'editdetail'">
                      <div v-if="imgreview" class="m-4">
                        <img :src="imgreview" alt="" srcset="" style="max-height: 100px;">
                      </div>
                    </div>
                  </div>
                </div>


                <div class="text-end">
                  <button type="button" class="btn btn-secondary btn-sm me-2" @click="closeModal">Close</button>
                  <button class="btn btn-primary btn-sm" :disabled="loading" @click="handleSubmit">
                    <span v-if="loading" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                    <span v-if="!loading">Submit</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>

</template>
<script>
import api from "@/utils/api";
// import axios from "axios";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import ImageUploader from "quill-image-uploader";
export default {
  data() {
    return {
      loading: false,
      serviceList: [], // Holds the list of banners
      currentPage: 1, // Track the current page
      totalPages: [], // Total number of pages
      itemsPerPage: 5,
      sortOrder: 'asc',
      searchQuery: '',
      pages: 'advisory',
      showModal: false, // Controls modal visibility
      formData: {
        pages: 'advisory',
        title: '',
        cover: null,
        files: [],
        desciption: [],
        icon: '',
        is_active: true
      },
      method: 'add',
      alertstatus: null,
      alerttext: null,
      jmldetail: [{}],
      dataCategory: [],
      selectCategory: '',
      iconList: [
        { name: "Icon 1", icon: "/icons/01.png" },
        { name: "Icon 2", icon: "/icons/02.png" },
        { name: "Icon 3", icon: "/icons/03.png" },
        { name: "Icon 4", icon: "/icons/04.png" },
        { name: "Icon 5", icon: "/icons/05.png" },
        { name: "Icon 6", icon: "/icons/06.png" },
        { name: "Icon 7", icon: "/icons/07.png" },
        { name: "Icon 8", icon: "/icons/08.png" },
        { name: "Icon 9", icon: "/icons/09.png" },
        { name: "Icon 10", icon: "/icons/10.png" },
        { name: "Icon 11", icon: "/icons/11.png" },
        { name: "Icon 12", icon: "/icons/12.png" },
        { name: "Icon 13", icon: "/icons/13.png" },
        { name: "Icon 14", icon: "/icons/14.png" },
        { name: "Icon 15", icon: "/icons/15.png" },
        { name: "Icon 16", icon: "/icons/16.png" },
        { name: "Icon 17", icon: "/icons/17.png" },
        { name: "Icon 18", icon: "/icons/18.png" },
        { name: "Icon 19", icon: "/icons/19.png" },
        { name: "Icon 20", icon: "/icons/20.png" },
        { name: "Icon 21", icon: "/icons/21.png" },
        { name: "Icon 22", icon: "/icons/22.png" },
        { name: "Icon 23", icon: "/icons/23.png" },
        { name: "Icon 24", icon: "/icons/24.png" },
        { name: "Icon 25", icon: "/icons/25.png" },
      ],
      imgreview: null,
    };
  },
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    ArgonAlert,
    QuillEditor
  },
  setup: () => {
    const modules = {
      name: 'imageUploader',
      module: ImageUploader,
      options: {
        upload: file => {
          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("attachment", file);

            api.post('/admin/upload/editor/service', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
              .then(res => {
                resolve(res.data.data?.attachment);
              })
              .catch(err => {
                reject("Upload failed");
                console.error("Error:", err);
              });

          })
        }
      }
    };
    return { modules }
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        this.getcategoryList();
      }
    },
    "formData.pages"() {
      this.getcategoryList();
    },
  },
  mounted() {
    // Fetch the banner list when the component is mounted
    this.fetchService();
  },
  computed: {
    totalItems() {
      return this.serviceList.length;
    },
    paginatedData() {
      return this.serviceList.slice(0, this.itemsPerPage);
    },
  },
  methods: {
    async fetchService() {
      const config = {
        method: "get",
        url: "/admin/service",
        params: {
          sort: this.sortOrder,
          limit: this.itemsPerPage,
          paginate: this.currentPage,
          key_search: this.searchQuery,
          pages: this.pages
        },

      };
      await api[config.method](config.url, {
        params: {
          sort: this.sortOrder,
          limit: this.itemsPerPage,
          paginate: this.currentPage,
          key_search: this.searchQuery,
          pages: this.pages,
        }
      }).then((response) => {
          if (response.data?.message == 'success') {
            this.serviceList = response.data.data.service_list; // Assign banner_list to local data
            this.totalPages = response.data.data.paginate // Update the total number of pages (this depends on how the API returns pagination info)
          } else {
            this.alertstatus = 'danger';
            this.alerttext = 'Error get data'
          }

        })
        .catch((error) => {
          var err = error.response.data.message
          this.alertstatus = 'danger';
          this.alerttext = err
          console.error("Error fetching data:", error);
        });
    },
    async getcategoryList() {
      let access_token = localStorage.getItem('access_token');
      const config = {
        method: "get",
        url: "/admin/service_category",
        params: {
          sort: this.sortOrder,
          limit: 100,
          paginate: this.currentPage,
          key_search: this.formData.pages,

        },
        headers: {
          'Authorization': 'Bearer ' + access_token // Replace with the actual token
        },
      };

      await api[config.method](config.url, { params: { ...config.params } })
        .then((response) => {
          if (response.data?.message == 'success') {
            this.dataCategory = response.data.data.service_category_list; // Assign banner_list to local data


            // this.totalPagescategory = response.data.data.paginate // Update the total number of pages (this depends on how the API returns pagination info)
          } else {
            this.alertstatus = 'danger';
            this.alerttext = 'Error get data'
          }
        })
        .catch((error) => {
          var err = error.response.data.message
          this.alertstatus = 'danger';
          this.alerttext = err
          console.error("Error fetching data:", error);
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages.length) {
        this.currentPage++;
        this.fetchService();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchService();
      }
    },
    setPage(page) {
      this.currentPage = page;
      this.fetchService();
    },
    updateItemsPerPage() {
      this.fetchService();
    },
    updatesoftby() {
      this.fetchService();
    },
    changepages() {
      this.fetchService();
    },
    cari() {
      this.fetchService();
    },
    truncateText(text, length) {
      if (text.length > length) {
        return text.slice(0, length) + '...';
      }
      return text;
    },
    truncateHTML(htmlContent, maxLength) {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = htmlContent || '';
      const textContent = tempElement.textContent || tempElement.innerText || '';

      // Potong teks jika panjangnya melebihi maxLength
      if (textContent.length > maxLength) {
        return textContent.slice(0, maxLength) + '...';
      }

      return htmlContent;
    },
    handlePages() {
      if (this.formData.pages == 'bom') {
        this.jmldetail = 3;
      } else {
        this.jmldetail = 2;
      }
    },
    closeModal() {
      this.showModal = false;
      // Reset form data
      this.file = null
      if (this.$refs.coverRef) {
        this.$refs.coverRef.value = "";
      }
      const editor = this.$refs.descriptionRef;
      
      if (editor?.length > 0) {
        editor.forEach(data => {
          data.getQuill().setText('') 
        })
      }
      if (this.$refs.fileRef?.length > 0 ) {
        this.$refs.fileRef.forEach(data => {
          data.value = "";
        })
      }
      this.formData = {
        pages: 'advisory',
        title: '',
        cover: null,
        files: [],
        desciption: [],
        icon: '',
        is_active: true
      }
      this.selectCategory = '';
      this.imgreview = null;
      this.logoPreview = null;
      this.method = 'add';
      this.jmldetail = [{}];
    },
    handleFileUpload(event, index) {
      const file = event.target.files[0];
      // Make sure the array has the correct length
      if (this.formData.files.length <= index) {
        this.formData.files.splice(index, 0, file);
      } else {
        this.formData.files[index] = file;
      }

    },
    handleFileUploadCover(event) {
      this.formData.cover = event.target.files[0]; // Capture the single cover file
      this.imgreview = URL.createObjectURL(event.target.files[0]); // Buat URL untuk preview gambar
    },
    handleFileUploaddetail(event) {
      this.formData.files = event.target.files[0]; // Capture the single cover file
      this.imgreview = URL.createObjectURL(event.target.files[0]); // Buat URL untuk preview gambar
    },
    addDetail() {
      this.jmldetail.push({ desciption: '', file: null });
    },
    removeDetail(index) {
      this.jmldetail.splice(index, 1);
    },

    async submitForm() {
      let access_token = localStorage.getItem('access_token');
      const data = new FormData();
      var config = {}

      // return;
      if (this.method == 'add') {

        data.append('pages', this.formData.pages);
        data.append('title', this.formData.title);
        data.append('category_id', this.selectCategory);
        data.append('icon', this.formData.icon);
        if (this.formData.cover) {
          data.append('cover', this.formData.cover);
        }

        // Tambahkan deskripsi
        this.formData.desciption.forEach((desc, index) => {
          data.append(`description[${index}]`, desc);
        });
        // Append files to FormData
        this.formData.files.forEach((file) => {
          data.append('file', file);
        });

        config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: '/admin/service',
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          },
          data: data,
        };
      } else if (this.method == 'edit') {
        data.append('title', this.formData.title);
        data.append('category_id', this.selectCategory);
        data.append('icon', this.formData.icon);
        data.append('is_active', this.formData.is_active);
        if (this.formData.cover) {
          data.append('cover', this.formData.cover);
        }

        config = {
          method: 'put',
          maxBodyLength: Infinity,
          url: '/admin/service/' + this.formData.id,
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          },
          data: data,
        }
      } else {
        data.append('description', this.formData.desciption);
        data.append('file', this.formData.files);

        config = {
          method: 'put',
          maxBodyLength: Infinity,
          url: '/admin/service_detail/' + this.formData.id,
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          },
          data: data,
        }
      }

      try {

        this.loading = true;
        const response = await api[config.method](config.url, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.data?.message == 'success') {
          this.fetchService();
          if (this.method == 'add') {
            this.$swal({
              title: "Success!",
              text: "Add data success",
              icon: "success"
            });
          } else {
            this.$swal({
              title: "Success!",
              text: "Edit data success",
              icon: "success"
            });
          }
          // setTimeout(function () {
          //   window.location.reload(1);
          // }, 1500);

          this.closeModal(); // Close modal after successful submission
        } else {
          this.alertstatus = 'danger';
          this.alerttext = 'Error add data'
        }
      } catch (error) {
        var err = error.response.data.data

        this.$swal({
          title: error.response.data.message,
          text: err,
          icon: "warning",
          confirmButtonColor: "#3085d6",
        });
      } finally {
        this.loading = false;
      }
    },

    async hapus(id) {
      let access_token = localStorage.getItem('access_token');
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      });

      if (result.isConfirmed) {
        const config = {
          method: 'delete', // Ganti ke delete jika API menggunakan method ini
          maxBodyLength: Infinity,
          url: '/admin/service/' + id,
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          }
        };

        try {
          const response = await api[config.method](config.url);
          if (response.data?.message == 'success') {
            await this.fetchService(); // Refresh banner list after deletion
            this.$swal({
              title: "Deleted!",
              text: "Your data has been deleted.",
              icon: "success"
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "There was an issue deleting the data.",
              icon: "error"
            });
          }
        } catch (error) {
          this.$swal({
            title: "Error!",
            text: "Failed to delete the data.",
            icon: "error"
          });
        }
      }
    },

    edit(item) {
      this.formData = {
        pages: item?.pages,
        title: item?.title,
        cover: null,
        file: null,
        desciption: [''],
        id: item.id,
        icon: item.icon,
        is_active: item.is_active
      };
      this.imgreview = item.cover;
      this.selectCategory = item?.category_service_data?.id
      this.showModal = true;
      this.method = 'edit';
    },
    editdetail(item) {
      this.formData = {
        desciption: item.description,
        files: [],
        id: item.id,
        pages: 'advisory',
      };
      this.imgreview = item.file;
      this.showModal = true;
      this.method = 'editdetail';

    },
    getProcessedDescription(description) {
      return description.replace(/<img /g, '<img class="img-fluid" ');
    },
    async moveUp(index, id) {
      
      if (index > 0) {
        [this.serviceList[index - 1], this.serviceList[index]] = [
          this.serviceList[index],
          this.serviceList[index - 1],
        ];

        // Trigger reactivity update
        this.serviceList = [...this.serviceList];
      }
      const newIndex = this.serviceList.findIndex((data) => data.id ===id);
      // return;

      let access_token = localStorage.getItem("access_token");

      const config = {
        method: "put",
        maxBodyLength: Infinity,
        url:
          "/admin/service_direction/" +
          id,
        headers: {
          Authorization: "Bearer " + access_token, // Replace with the actual token
        },
        data: {
          direction: newIndex + 1
        },
      };

      try {
        this.loading = true;

        await api.put(config.url, config.data);

        this.fetchService();
      } catch (error) {
        console.log({ error })
      }


    },

    async moveDown(index, id) {
      if (index < this.serviceList.length - 1) {
        [this.serviceList[index], this.serviceList[index + 1]] = [
          this.serviceList[index + 1],
          this.serviceList[index],
        ];

        // Trigger reactivity update
        this.serviceList = [...this.serviceList];
      }
      const newIndex = this.serviceList.findIndex((data) => data.id ===id);

      let access_token = localStorage.getItem("access_token");

      const config = {
        method: "put",
        maxBodyLength: Infinity,
        url:
          "/admin/service_direction/" +
          id,
        headers: {
          Authorization: "Bearer " + access_token, // Replace with the actual token
        },
        data: {
          direction: newIndex + 1
        },
      };

      try {
        this.loading = true;

        await api.put(config.url, config.data);

        this.fetchService();
      } catch (error) {
        console.log({ error })
      }


    },
  },
};
</script>
<style>
/* Optional: Ensure modal is shown properly */
.modal.show {
  display: block;
  /* Override display to block */
}

.modal-backdrop {
  opacity: 50%;
}

.large-editor {
  height: 300px !important;
  /* Atur tinggi editor */
  width: 100%;
  /* Lebar menyesuaikan kontainer */
}

.large-editor .ql-container {
  min-height: 400px;
  /* Atur area konten */
}

.large-editor .ql-editor {
  font-size: 16px;
  /* Ukuran teks */
  padding: 16px;
  /* Ruang di dalam editor */
}

.custom-width-modal {
  max-width: 100% !important;
  margin-left: 17.125rem !important;
}
</style>